export const inRange = (x: number, min: number, max: number) => {
  if (!min || !max) return false;
  return (x - min) * (x - max) <= 0;
};
